import { Button, TableWrapper, UploadVehicleImage } from 'components/Global';
import { ReactComponent as CarIcon } from 'icons/car-filled-logo.svg';
import { useSelector } from 'react-redux';
import { checkPermission } from 'utils/functionality';
import { useFliptBoolean } from '@flipt-io/flipt-client-react';
import ReviewVehicleCard from '../ReviewVehicleCard';
import RatingVehicleCard from '../RatingVehicleCard';

const ContentRight = ({ imageFiles, handleRemove, vehicle }) => {
  const { offCanvasMenu, currentMenu } = useSelector((state) => state.menu);
  const { reviews: reviewData, reviewsLoading: reviewLoading } = useSelector((state) => state.vehicle);
  const user = useSelector((state) => state.user.profile);

  const isAddVehicleState = location.pathname.includes('add-vehicle');

  const isEnhancementReviewDriver = useFliptBoolean('FLAG_FE_ENHANCEMENT_REVIEW_DRIVER', false, user.id || 'anonymous');

  const renderReviewRatingVehicle = () => {
    if (isAddVehicleState) return null;

    if (isEnhancementReviewDriver) {
      return <ReviewVehicleCard data={vehicle} reviewData={reviewData} reviewLoading={reviewLoading} />;
    } else {
      return <RatingVehicleCard data={vehicle} />;
    }
  };

  return (
    <div className="content--right">
      <div className="content--right__upload">
        <TableWrapper icon={<CarIcon fill="#009EF7" width="25px" height="25px" />} title="Foto Mobil">
          <p>Foto Mobil</p>
          <UploadVehicleImage previewable imageFiles={imageFiles} handleRemove={handleRemove} />
        </TableWrapper>
      </div>

      {renderReviewRatingVehicle()}

      {/* SUBMIT BUTTON */}
      {(isAddVehicleState || checkPermission(offCanvasMenu, currentMenu, 'update')) && (
        <div className="content--right__button">
          <Button type="submit" size="sm" className="button" width="267px">
            Simpan
          </Button>
        </div>
      )}
    </div>
  );
};

export default ContentRight;
